import { fetch } from 'whatwg-fetch'

export const get = url => _fetch(url, "GET");

export const post = (url, data, abortController = null) => _fetch(url, "POST", data, abortController);
export const put = (url, data, abortController = null) => _fetch(url, "PUT", data, abortController);
export const patch = (url, data, abortController = null) => _fetch(url, "PATCH", data, abortController);
export const remove = (url, data, abortController = null) => _fetch(url, "DELETE", data, abortController);

export const postGetBlob = (url, data, abortController = null) => _blob(url, "POST", data, abortController);

const _fetch = (url, method, data = null, abortController = null, contentType = 'application/json') => {
    let options = {
        method,
        headers: {
            'litium-request-context': JSON.stringify(window.__litium.requestContext),
        },
        credentials: 'include',
    };
    if (abortController) {
        options.signal = abortController.signal;
    }
    if (method !== "GET") {
        options = {
            ...options,
            body: data ? JSON.stringify(data) : null,
            headers: {
                ...options.headers,
                'content-type': contentType,
            }
        };

        const token = window.localStorage.getItem('requestVerificationToken');
        if (token) {
            options = {
                ...options,
                headers: {
                    ...options.headers,
                    'RequestVerificationToken': token,
                }
            }
        }
    }
    // use native browser implementation if it supports aborting
    const abortableFetch = ('signal' in new Request('')) ? window.fetch : fetch;
    return abortableFetch(url, options)
        .then(_checkStatus);
};


const _blob = (url, method, data = null) => {
    var request = new XMLHttpRequest();
    request.open(method, url, true);
    //request.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded; charset=UTF-8');
    request.setRequestHeader('Content-Type', 'application/json');
   
    request.setRequestHeader('litium-request-context', JSON.stringify(window.__litium.requestContext));

    const token = window.localStorage.getItem('requestVerificationToken');
    if (token) {
        request.setRequestHeader('RequestVerificationToken', token);
    }
    
    request.responseType = 'blob';

    request.onload = function () {
        // Only handle status code 200
        if (request.status === 200) {
            // Try to find out the filename from the content disposition `filename` value
            var disposition = request.getResponseHeader('content-disposition');
            var matches = /"([^"]*)"/.exec(disposition);
            var filename = (matches != null && matches[1] ? matches[1] : 'file.pdf');

            // The actual download
            var blob = new Blob([request.response], { type: 'application/pdf' });
            var link = document.createElement('a');
            link.href = window.URL.createObjectURL(blob);
            link.download = filename;

            document.body.appendChild(link);

            link.click();

            document.body.removeChild(link);
        }

        // some error handling should be done here...
    };
    var obj = {
            body: data,
    }
    alert("HEPP=" + JSON.stringify(obj));
    request.send(JSON.stringify(obj));
};

const _checkStatus = response => {
    if (response.status >= 200 && response.status < 300) {
        return response;
    } else {
        let error = new Error(response.statusText);
        error.response = response;
        throw error;
    }
};